import React from 'react'
import { InputDescription, InputError, InputWrapper, InputLabel } from '../NFTInput/styled'
import { RangeInputField, RangeInputWrapper } from './styled'
import INFTRangeSlider from './INFTRangeSlider'

export default function NFTRangeSlider(props: INFTRangeSlider) {
  const {
    errorMessage,
    id,
    htmlFor,
    placeholder,
    name,
    label,
    description,
    onKeyUp,
    optional,
    value,
    validate,
    isValid,
    max,
    min
  } = props

  return (
    <InputWrapper>
      <InputLabel htmlFor={htmlFor ? htmlFor : id}>
        {label ? label + " : " : ""}{value}% {optional && <span>(Optional)</span>}
      </InputLabel>
      <RangeInputWrapper>
        <RangeInputField
          className={errorMessage || isValid === false ? 'error' : ''}
          id={id}
          name={name}
          type="range"
          placeholder={placeholder}
          value={value}
          max={max}
          min={min}
          validate={validate}
          onChange={(e: any) => {
            if (onKeyUp) {
              onKeyUp(e.currentTarget.value)
            }
          }}
        />
      </RangeInputWrapper>
      {description && <InputDescription>{description}</InputDescription>}
      {errorMessage && <InputError>{errorMessage}</InputError>}
    </InputWrapper>
  )
}
